/**
 * RecoverPasswordRequest
 * @author Simpli CLI generator
 */
import {$, Model, sleep} from 'simpli-web-sdk'
import {
  ResponseHidden,
  ValidationMaxLength,
  ValidationPasswordLength,
} from 'simpli-web-sdk'

export default class RecoverPasswordRequest extends Model {
  readonly $name: string = 'RecoverPasswordRequest'

  @ResponseHidden()
  @ValidationPasswordLength(6, 100)
  newPassword: string | null = null

  @ResponseHidden()
  newPassword2: string | null = null

  @ResponseHidden()
  @ValidationPasswordLength(6, 100)
  confirmPassword: string | null = null

  @ResponseHidden()
  confirmPassword2: string | null = null

  @ValidationMaxLength(255)
  hash: string | null = null
}
